<template>
  <div class="fast-help-modal">
    <div class="fast-help-modal-content">
      <h3>Soyez précis afin de recevoir des propositions pertinentes</h3>
      <p>
        Décrivez votre besoin de façon détaillée : contexte du projet, missions à réaliser, résultat attendu, compétences
        requises, contrainte technique...
      </p>
      <p>N’inscrivez pas vos coordonnées à cette étape.</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .fast-help-modal {
    .webp & {
      background-image: url('../images/marketing-message-bg.webp');
    }
    .no-compressedimage & {
      background-image: url('../images/marketing-message-bg.png');
    }
  }
}
</style>
